import type {RootState} from "../store";
import {
    INITIAL_IVR_CONFIGURATION_DATA,
    IVR_CONFIGURATION_CLEAR_FILTERS,
    IVR_CONFIGURATION_DIALOG_VISIBLE,
    IVR_CONFIGURATION_FIELD,
    SELECTED_IVR_CONFIGURATION_ID,
    SET_IVR_CONFIGURATION_CURRENT_PAGE,
    SET_IVR_CONFIGURATION_CURRENT_SIZE,
    SET_IVR_CONFIGURATION_ERROR_FIELDS,
    SET_IVR_SCHEME_GRAPH_API_SLICE,
    SHOW_IVR_CONFIGURATION_LOADER,
} from "../types/typesIVRConfigurationList";

export function setIVRConfigurationDialogVisible(state: boolean) {
    return {
        type: IVR_CONFIGURATION_DIALOG_VISIBLE,
        payload: state,
    }
}

export function setSelectedIVRConfigurationIndex(state: number) {
    return {
        type: SELECTED_IVR_CONFIGURATION_ID,
        payload: state,
    }
}

export function setIVRConfigurationField(state: { fieldName: string, value: any }) {
    return {
        type: IVR_CONFIGURATION_FIELD,
        payload: state,
    }
}

export function setIVRConfigurationClearFilters() {
    return {
        type: IVR_CONFIGURATION_CLEAR_FILTERS,
    }
}

export function showIVRConfigurationLoader(state: boolean) {
    return {
        type: SHOW_IVR_CONFIGURATION_LOADER,
        payload: state,
    }
}

export function initialIVRConfigurationData() {
    return {
        type: INITIAL_IVR_CONFIGURATION_DATA,
    }
}

export function setIVRConfigurationErrorFields(state: any) {
    return {
        type: SET_IVR_CONFIGURATION_ERROR_FIELDS,
        payload: state,
    }
}

export function setIVRConfigurationCurrentPage(state: any) {
    return {
        type: SET_IVR_CONFIGURATION_CURRENT_PAGE,
        payload: state
    }
}

export function setIVRConfigurationCurrentPageSize(state: any) {
    return {
        type: SET_IVR_CONFIGURATION_CURRENT_SIZE,
        payload: state
    }
}

export function setIvrSchemeGraphApiSlice(payload: {
    elements: unknown[];
    routes: unknown[];
    schedules: unknown[];
    configurationPatch: { entryElementId: number | null };
    schedulesServerSnapshotReplace?: unknown[];
}) {
    return {
        type: SET_IVR_SCHEME_GRAPH_API_SLICE,
        payload,
    };
}

export function removeIvrElementAudioFromStore(
    elementId: number,
    audioId: number
) {
    return (dispatch: (a: ReturnType<typeof setIvrSchemeGraphApiSlice>) => void, getState: () => RootState): boolean => {
        const cur = getState().IVRConfigurationReducer
            .ivrConfigurationData as Record<string, unknown>;
        const elementsRaw = (cur.elements as unknown[] | undefined) ?? [];
        const elements = [...elementsRaw];
        const idx = elements.findIndex((e) => {
            const row = e as { elementId?: unknown };
            return Number(row.elementId) === Number(elementId);
        });
        if (idx < 0) return false;
        const prevEl = elements[idx] as {
            audios?: { audioId?: unknown }[] | null;
        };
        elements[idx] = {
            ...prevEl,
            audios: (prevEl.audios ?? []).filter(
                (a) => Number(a?.audioId) !== Number(audioId)
            ),
        };
        const conf = (cur.configuration as Record<string, unknown>) ?? {};
        const rawEntry = conf.entryElementId;
        let entryElementId: number | null = null;
        if (rawEntry != null) {
            const n =
                typeof rawEntry === "number"
                    ? rawEntry
                    : Number(String(rawEntry).trim());
            if (Number.isFinite(n)) entryElementId = n;
        }
        dispatch(
            setIvrSchemeGraphApiSlice({
                elements,
                routes: (cur.routes as unknown[]) ?? [],
                schedules: (cur.schedules as unknown[]) ?? [],
                configurationPatch: {
                    entryElementId,
                },
            })
        );
        return true;
    };
}

